var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.clearCookie}},[_vm._v("\n        清楚token\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }